import DynamicComponent from "./DynamicComponent";
import type { SBComponent, SBComponents, GlobalComponent, RegularComponent } from "./DynamicComponent.d";

const extractGlobalComponentBody = (blok: GlobalComponent): RegularComponent[] | null =>
  blok.reference.content?.global || null;

const isGlobalComponent = (blok: SBComponent): blok is GlobalComponent => blok.component === "global_reference";

export const renderDynamicComponent = (body: SBComponents) => {
  if (!body) return null;

  return body.map((blok) => {
    if (isGlobalComponent(blok)) {
      const globalComponentBody = extractGlobalComponentBody(blok);

      return renderDynamicComponent(globalComponentBody);
    }

    return <DynamicComponent blok={blok} key={blok._uid} />;
  });
};
